import React from 'react';
import { WebsiteDesignProps } from './types';
import { Globe2, HeartHandshake, Languages, Plane } from 'lucide-react';
import { Button } from "@/components/ui/button";

const GlobalCitizen: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "WorldView International";

    return (
        <div className="bg-white text-slate-900 min-h-screen font-sans">
             <div className="bg-[#003366] text-white py-2 px-6 flex justify-between items-center text-xs font-bold uppercase tracking-widest">
                 <div className="flex gap-4">
                     <span>London</span>
                     <span>Dubai</span>
                     <span>Singapore</span>
                     <span>New York</span>
                 </div>
                 <div className="flex gap-2 items-center">
                     <Languages size={14} /> English | Français | Español
                 </div>
             </div>

             <nav className="border-b border-gray-100 py-6">
                 <div className="container mx-auto px-6 flex justify-between items-center">
                     <div className="text-2xl font-serif text-[#003366] font-bold flex gap-2 items-center">
                         <Globe2 /> {schoolName}
                     </div>
                     <div className="hidden md:flex gap-8 text-[#003366] font-medium">
                         <a href="#">Curriculum</a>
                         <a href="#">Campuses</a>
                         <a href="#">Admissions</a>
                     </div>
                     <Button variant="outline" className="border-[#003366] text-[#003366] hover:bg-[#003366] hover:text-white rounded-none uppercase text-xs font-bold tracking-widest px-6">
                         Apply
                     </Button>
                 </div>
             </nav>

             {/* Map Background Concept */}
             <section className="relative py-24 bg-[#f4f7f9] overflow-hidden">
                 <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative z-10">
                     <div className="order-2 lg:order-1">
                          <img src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?q=80&w=2069&auto=format&fit=crop" className="rounded-sm shadow-xl w-full" alt="Diverse Group" />
                     </div>
                     <div className="order-1 lg:order-2">
                         <h1 className="text-5xl font-serif text-[#003366] mb-6 leading-tight">
                             Educating the <br/> Global Citizens of Tomorrow.
                         </h1>
                         <p className="text-slate-600 text-lg mb-8 leading-relaxed">
                             We prepare students to thrive in an interconnected world, fostering cultural understanding, multilingualism, and diverse perspectives.
                         </p>
                         <div className="grid grid-cols-2 gap-6">
                             <div className="flex gap-3 items-start">
                                 <div className="mt-1 bg-[#003366] p-1 rounded-full text-white"><Plane size={14} /></div>
                                 <div className="text-sm text-slate-600"><strong>Exchange Programs</strong><br/>in 40+ countries</div>
                             </div>
                             <div className="flex gap-3 items-start">
                                 <div className="mt-1 bg-[#003366] p-1 rounded-full text-white"><HeartHandshake size={14} /></div>
                                 <div className="text-sm text-slate-600"><strong>Service Learning</strong><br/>Global impact projects</div>
                             </div>
                         </div>
                     </div>
                 </div>
             </section>

             <section className="py-20 bg-[#003366] text-white text-center">
                 <div className="container mx-auto max-w-4xl">
                     <h2 className="text-3xl font-serif mb-8">"The world is a book and those who do not travel read only one page."</h2>
                     <Button className="bg-white text-[#003366] hover:bg-gray-100 rounded-none px-8 py-6 uppercase font-bold tracking-widest">
                         Start Your Journey
                     </Button>
                 </div>
             </section>
        </div>
    );
};

export default GlobalCitizen;
